module.exports = __webpack_public_path__ + "static/media/summer ladies coordinator.4f5f1249.jpg";